import { createApi } from '@reduxjs/toolkit/query/react';

import {
  CapitalRequestMatch,
  RequestMessage,
  RequestQuestion,
} from '@scaleup/models';
import { baseQuery } from './baseQuery';
import { TagTypes } from './tagTypes';

export const capitalRequestMatchApi = createApi({
  reducerPath: 'capitalRequestMatchApi',
  baseQuery: baseQuery,
  tagTypes: [TagTypes.capitalRequestMatches],
  endpoints: (builder) => ({
    getCapitalRequestMatches: builder.query<CapitalRequestMatch[], void>({
      query: () => '/capital_request_match',
      providesTags: [TagTypes.capitalRequestMatches],
    }),
    getCrmQuestions: builder.query<RequestQuestion[], string>({
      query: (matchId) => `/capital_request_match/${matchId}/question`,
    }),
    createCrmQuestions: builder.mutation<
      void,
      { matchId: string; questions: string[] }
    >({
      query: ({ matchId, questions }) => ({
        url: `/capital_request_match/${matchId}/question`,
        method: 'POST',
        body: [...questions],
      }),
      invalidatesTags: [TagTypes.capitalRequestMatches],
    }),
    crmOptIn: builder.mutation<void, { matchId: string; optIn: boolean }>({
      query: ({ matchId, optIn }) => ({
        url: `/capital_request_match/${matchId}`,
        method: 'POST',
        body: { optIn },
      }),
      invalidatesTags: [TagTypes.capitalRequestMatches],
    }),
    createCrmMessage: builder.mutation<
      void,
      { matchId: string; message: string }
    >({
      query: ({ matchId, message }) => ({
        url: `/capital_request_match/${matchId}/message`,
        method: 'POST',
        body: { message },
      }),
      invalidatesTags: [TagTypes.capitalRequestMatches],
    }),
    getCrmMessages: builder.query<RequestMessage[], string>({
      query: (matchId) => `/capital_request_match/${matchId}/message`,
    }),
    dealStatusCrm: builder.mutation<
      void,
      { matchId: string; dealWon: boolean }
    >({
      query: ({ matchId, dealWon }) => ({
        url: `/capital_request_match/${matchId}`,
        method: 'POST',
        body: { dealWon },
      }),
      invalidatesTags: [TagTypes.capitalRequestMatches],
    }),
  }),
});

export const {
  useGetCapitalRequestMatchesQuery,
  useGetCrmQuestionsQuery,
  useCreateCrmQuestionsMutation,
  useCrmOptInMutation,
  useCreateCrmMessageMutation,
  useGetCrmMessagesQuery,
  useDealStatusCrmMutation,
} = capitalRequestMatchApi;
